module.exports = __webpack_public_path__ + "img/register.8dc366fd.png";